module.exports = __webpack_public_path__ + "img/toggle-grid.3d916037.svg";